import { render } from "./AnswerCarouselImageForm.vue?vue&type=template&id=3d05f330&scoped=true"
import script from "./AnswerCarouselImageForm.vue?vue&type=script&lang=ts"
export * from "./AnswerCarouselImageForm.vue?vue&type=script&lang=ts"

import "./AnswerCarouselImageForm.vue?vue&type=style&index=0&id=3d05f330&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3d05f330"

export default script
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QFile from 'quasar/src/components/file/QFile.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QItemSection,QCarousel,QCarouselSlide,QAvatar,QBtn,QFile});
